const gridPreferencePanelStateSelector = (state) => state.preferencePanel;
export {
  gridPreferencePanelStateSelector
};
//# sourceMappingURL=gridPreferencePanelSelector.es.js.map
